import querystring from 'querystring'

import * as AT from './_types'
import fetchApi from '../../services/fetchApi'

export function selectMenu(menuId, menuType, view) {
  return {
    type: AT.PATIENTS_GROUPS_SELECT,
    selectedMenu: { id: menuId, type: menuType },
    view,
  }
}

export function updatePatientSearch(searchTerm) {
  return {
    type: AT.PATIENTS_GROUPS_UPDATE_SEARCH,
    search: searchTerm,
  }
}

export function updatePatientsAllLocations(allLocations) {
  return {
    type: AT.PATIENTS_GROUPS_UPDATE_ALL_LOCATIONS,
    allLocations,
  }
}

export const togglePatientStatusFilter = hasStatusFilter => dispatch =>
  dispatch({
    type: AT.PATIENTS_GROUPS_ADD_STATUS_FILTER,
    hasStatusFilter,
  })

export const toggleApptTypeFilter = hasApptTypeFilter => dispatch =>
  dispatch({
    type: AT.PATIENTS_GROUPS_ADD_APPT_TYPE_FILTER,
    hasApptTypeFilter,
  })

export function changeView(view) {
  return {
    type: AT.PATIENTS_GROUPS_CHANGE_VIEW,
    view,
  }
}

export const fetchDoctorsAndLocationsAndStatuses = () => async dispatch => {
  try {
    const locs = await fetchApi('/account/locations')
    const docs = await fetchApi('/account/doctors')
    const statuses = await fetchApi('/patient_statuses')
    dispatch(setDoctorsAndLocationsAndStatuses(docs, locs, statuses))
  } catch (err) {
    dispatch(handleFetchError(err))
  }
}

export const fetchPatients =
  (queryparams, page, locationId = null, allLocations = false, fetchController = null) =>
  dispatch => {
    dispatch(startFetching())
    dispatch(fetchDoctorsAndLocationsAndStatuses())

    const queryObject = { ...queryparams, page, all_locations: allLocations }
    if (locationId) queryObject.location_id = locationId

    const params = querystring.stringify(queryObject)
    return fetchApi(`/patients?${params}`, 'GET', { fetchController })
      .then(res => res)
      .catch(err => {
        return Promise.reject(err)
      })
  }

export const fetchPatientsThenSave =
  (queryparams, page, locationId = null, allLocations = false, fetchController = null) =>
  dispatch =>
    dispatch(fetchPatients(queryparams, page, locationId, allLocations, fetchController))
      .then(
        res => {
          dispatch(
            savePatients(res.total_patients, res.patients, res.total_pages, page),
          )
          return Promise.resolve()
        },
      )
      .catch(err => {
        dispatch(handleFetchError(err))
      })

export const fetchGroups = () => dispatch =>
  fetchApi('/patients/groups').then(res => {
    dispatch(saveGroupList(res))
    return Promise.resolve()
  })

export const fetchAllPatientsInGroup = groupId => dispatch => {
  dispatch(startFetching())
  return fetchApi(`/patients/groups/${groupId}`)
    .then(res => {
      dispatch(savePatients(res.total_patients, res.patients, 1, 1))
      return Promise.resolve()
    })
    .catch(err => {
      dispatch(handleFetchError(err))
      return Promise.reject(err)
    })
}

function savePatients(totalPatients, patients, totalPages, page) {
  return {
    type: AT.PATIENTS_GROUPS_RECEIVE_PATIENTS,
    totalPatients,
    patients,
    totalPages,
    currentPage: page,
  }
}

function saveGroupList(res) {
  return {
    type: AT.PATIENTS_GROUPS_RECEIVE_GROUPS,
    groups: res,
  }
}

function handleFetchError(error) {
  return {
    type: AT.PATIENTS_GROUPS_REQUEST_FAILURE,
    error,
  }
}

function startFetching() {
  return {
    type: AT.PATIENTS_GROUPS_REQUEST,
  }
}

function setDoctorsAndLocationsAndStatuses(doctors, locations, statuses) {
  return {
    type: AT.PATIENTS_GROUPS_RECEIVE_DOCTORS_AND_LOCATIONS_AND_STATUSES,
    doctors,
    locations,
    statuses,
  }
}



// WEBPACK FOOTER //
// ./src/state/actions/patient-groups.js